import { Play } from "lucide-react";

export default function EpisodeCard({ ep, onPlay }) {
  return (
    <article
      className="group bg-[#0F0F0F] border border-white/5 hover:border-gold/40 transition-all overflow-hidden flex flex-col"
      data-testid={`episode-card-${ep.id}`}
    >
      <button
        onClick={() => onPlay(ep)}
        className="relative aspect-video overflow-hidden bg-black"
        data-testid={`episode-play-${ep.id}`}
      >
        {ep.thumbnail_url ? (
          <img
            src={ep.thumbnail_url}
            alt={ep.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-neutral-800 to-black" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="rounded-full bg-svn-red p-4 shadow-2xl">
            <Play className="text-white fill-white" size={24} />
          </span>
        </div>
        {ep.duration && (
          <span className="absolute bottom-3 right-3 bg-black/80 text-white text-xs font-bold px-2 py-1">
            {ep.duration}
          </span>
        )}
      </button>
      <div className="p-5 flex flex-col gap-2 flex-1">
        <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-gold">
          {ep.show_slug?.replace(/-/g, " ")}
        </p>
        <h3 className="font-display font-bold text-base text-white leading-tight">
          {ep.title}
        </h3>
        {ep.description && (
          <p className="text-sm text-neutral-400 line-clamp-2 font-body">
            {ep.description}
          </p>
        )}
      </div>
    </article>
  );
}
